import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Menu, X, LogOut, LayoutDashboard, Shield } from "lucide-react";

function Logo() {
  return (
    <Link to="/" className="flex items-center gap-2.5 group">
      <div className="h-10 w-10 rounded-2xl bg-black border-2 border-[#ff3798] flex items-center justify-center shadow-[0_0_16px_rgba(255,55,152,0.35)] group-hover:shadow-[0_0_24px_rgba(255,55,152,0.6)] transition-shadow">
        <span className="font-logo text-[#ff3798] text-[15px] leading-none">H</span>
      </div>
      <div className="leading-none pb-0.5">
        <span className="font-script text-[26px] text-[#ff3798]">Hair</span><span className="font-script text-[26px] text-white">Mama</span>
      </div>
    </Link>
  );
}

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  const isLanding = location.pathname === "/";
  const scrollTo = (id) => {
    if (!isLanding) { navigate("/"); return; }
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  const handleLogout = () => { logout(); window.location.href = "/"; };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "bg-[#0b0b0d]/85 backdrop-blur-xl border-b border-white/10" : "bg-transparent"}`}>
      <div className="max-w-7xl mx-auto px-5 h-[72px] flex items-center justify-between">
        <Logo />

        <nav className="hidden md:flex items-center gap-8 text-sm text-white/70">
          {isLanding && (
            <>
              <button onClick={() => scrollTo("courses")} className="hover:text-white transition-colors">Курсы</button>
              <button onClick={() => scrollTo("how")} className="hover:text-white transition-colors">Преимущества</button>
              <button onClick={() => scrollTo("reviews")} className="hover:text-white transition-colors">Отзывы</button>
            </>
          )}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              {user.role === "admin" && (
                <Link to="/admin" className="flex items-center gap-1.5 text-sm text-white/80 hover:text-[#ff3798] transition-colors"><Shield size={16} /> Админ</Link>
              )}
              <Link to="/dashboard" className="flex items-center gap-1.5 text-sm text-white/80 hover:text-white transition-colors"><LayoutDashboard size={16} /> Кабинет</Link>
              <button onClick={handleLogout} className="flex items-center gap-1.5 rounded-full border border-white/15 px-4 py-2 text-sm hover:border-[#ff3798] hover:text-[#ff3798] transition-colors"><LogOut size={15} /> Выйти</button>
            </>
          ) : (
            <>
              <Link to="/auth" className="text-sm text-white/80 hover:text-white transition-colors">Войти</Link>
              <Link to="/auth?mode=register" className="rounded-full bg-[#ff3798] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#ff5aac] transition-colors shadow-[0_8px_24px_-8px_rgba(255,55,152,0.8)]">Начать</Link>
            </>
          )}
        </div>

        <button className="md:hidden text-white" onClick={() => setOpen(!open)}>{open ? <X /> : <Menu />}</button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0b0b0d]/95 backdrop-blur-xl border-t border-white/10 px-5 py-5 flex flex-col gap-4 animate-fade-up">
          {user ? (
            <>
              <Link to="/dashboard" className="text-white/80">Мой кабинет</Link>
              {user.role === "admin" && <Link to="/admin" className="text-white/80">Админ-панель</Link>}
              <button onClick={handleLogout} className="text-left text-[#ff3798]">Выйти</button>
            </>
          ) : (
            <>
              <Link to="/auth" className="text-white/80">Войти</Link>
              <Link to="/auth?mode=register" className="rounded-full bg-[#ff3798] px-5 py-2.5 text-center font-semibold">Начать</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}
